const tramigoOfferings = [
  {
    id: "basic",
    name: "Basic Plan",
    price: 75000,
    renewalPrice: 45000,
    installationPrice: 15000,
    subscriptionPeriod: "1 year (12 months)",
    benefits: [
      "24/7 GPS Tracking: Live vehicle location & route history",
      "Vehicle Immobilizer: Prevents unauthorized use of your vehicle",
      "Covers 1 year (12 months) subscription",
      "Additional one-time installation fee - N15,000",
      "Annual subscription renewal - N45,000",
    ],
    note: "There is a N15,000 device installation charge added. Only select this option if you are purhasing Vehicle Tracking on our platform for the first time",
  },
  {
    id: "basic-renew",
    name: "Basic Plan (Subscription Renewal)",
    price: 45000,
    renewalPrice: 45000,
    installationPrice: 0,
    subscriptionPeriod: "1 year (12 months)",
    benefits: [
      "24/7 GPS Tracking: Live vehicle location & route history",
      "Vehicle Immobilizer: Prevents unauthorized use of your vehicle",
      "Covers 1 year (12 months) subscription",
    ],
    note: "Select this option only if you are renewing the subscription after you have previously purchased the Basic or Advanced Plan",
  },
  {
    id: "advanced",
    name: "Advanced Plan",
    price: 425000,
    renewalPrice: 100000,
    installationPrice: 15000,
    subscriptionPeriod: "2 years",
    benefits: [
      "Fuel Monitoring: Track fuel levels in real-time, detect theft & leakages instantly.",
      "eSIM Technology: No SIM card hassles – seamless connectivity everywhere.",
      "24/7 GPS Tracking: Live vehicle location & route history.",
      "Vehicle Immobilizer: Prevents unauthorized use of your vehicle",
      "Driver Insights: Monitor driving behavior, reduce risks & improve efficiency.",
      "Operational Savings: Cut fuel waste, lower expenses & maximize profits.",
      "Covers 2yrs subscription",
      "Additional one-time installation fee - N15,000",
      "Annual subscription renewal - N100,000",
    ],
    note: "There is a N15,000 device installation charge added. Only select this option if you are purhasing Vehicle Tracking on our platform for the first time",
  },
  {
    id: "advanced-renew",
    name: "Advanced Plan (Subscription Renewal)",
    price: 100000,
    renewalPrice: 100000,
    installationPrice: 0,
    subscriptionPeriod: "1 year (12 months)",
    benefits: [
      "Fuel Monitoring: Track fuel levels in real-time, detect theft & leakages instantly.",
      "eSIM Technology: No SIM card hassles – seamless connectivity everywhere.",
      "24/7 GPS Tracking: Live vehicle location & route history.",
      "Vehicle Immobilizer: Prevents unauthorized use of your vehicle",
      "Driver Insights: Monitor driving behavior, reduce risks & improve efficiency.",
      "Operational Savings: Cut fuel waste, lower expenses & maximize profits.",
      "Covers 1 year (12 months) subscription",
    ],
    note: "Select this option only if you are renewing the subscription after you have previously purchased either the Basic or Advanced Plan",
  },
]

const vehicleTracking = [
  {
    id: "tramigo",
    name: "Tramigo",
    offerings: tramigoOfferings,
  },
]

const vehicleTrackingDocs = {
  key: "vt",
  name: "Vehicle Tracker subscription",
  description: "Subscription for GPS tracker for vehicles",
  connected: [],
  process: [],
  processingTime: 7,
  price: [],
  meta: {},
}

module.exports = {
  vehicleTracking,
  vehicleTrackingDocs,
}
